module.exports = __webpack_public_path__ + "static/electric-8a1e4a4849bffba2a89a4673b09f1787.jpg";